module.exports = __webpack_public_path__ + "img/couple2.43f32fdc.png";